import { createSlice } from "@reduxjs/toolkit";

const setEditOpDagSlice = createSlice({
  name: "editOpDag",
  initialState: null,
  reducers: {
    setEditOpDag: (state, action) => {
      return action.payload;
    },
  },
});

export const { setEditOpDag } = setEditOpDagSlice.actions;
export default setEditOpDagSlice.reducer;